// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TooltipWrapper-module__wrapper--1pVc7"};